import { Navigate, useLocation } from 'react-router-dom';

/**
 * `/llm-configs/*` → `/model-configs/*` (task 1074).
 *
 * LLM Configs were renamed Model Configs. React Router has no wildcard-to-
 * wildcard `<Navigate>`, so this maps the matched path itself: the remainder
 * after `/llm-configs` (a config id, `new`), the query string and the hash all
 * carry across, and `replace` keeps the old URL out of history so Back does
 * not bounce through it. Bookmarked and shared links keep working.
 */
export default function LegacyModelConfigsRedirect() {
  const { pathname, search, hash } = useLocation();
  const rest = pathname.replace(/^\/llm-configs/, '');
  return <Navigate to={`/model-configs${rest}${search}${hash}`} replace />;
}
